module.exports = __webpack_public_path__ + "img/exe.088306f1.png";